module.exports = __webpack_public_path__ + "img/tve.4889b21e.png";